import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import siteReducer from "./features/siteSlice";
import drawerReducer from "./features/drawerSlice";
import menuReducer from "./features/roleWiseMenuSlice";
import alertReducer from "./features/alertSlice";

/* 🔹 Combine reducers */
const rootReducer = combineReducers({
    site: siteReducer,
    drawer: drawerReducer,
    menu: menuReducer,
    alert: alertReducer,
});

/* 🔹 Persist config */
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["site", "menu"], // 👈 persist only needed data
};

/* 🔹 Persisted reducer */
const persistedReducer = persistReducer(persistConfig, rootReducer);

/* 🔹 Store */
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // required for redux-persist
        }),
});

/* 🔹 Persistor */
export const persistor = persistStore(store);
